import {
  FETCH_ALL,
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  START_LOADING,
  END_LOADING,
  FETCH_INVOICE_BY_USER,
  FETCH_INVOICE_BY_RENTALID,
  FETCH_INVOICE_NUMBER,
  GET_ADD_NEW_INVOICE,
  ADD_NEW_RECEIPT,
  DOWNLOAD_PDF_INVOICE,
  RE_GENERATE_TRANSACTIONS,
} from "../actions/constants";

const invoices = (state = { isLoading: false, invoices: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ALL:
      return {
        ...state,
        invoices: action.payload.data,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_INVOICE_BY_USER:
      return {
        ...state,
        invoices: action.payload.invoices,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_INVOICE_BY_RENTALID:
      return {
        ...state,
        invoices: action.payload.invoices,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_INVOICE_NUMBER:
      return state;
    case DOWNLOAD_PDF_INVOICE:
      return state;
    case GET_ADD_NEW_INVOICE:
      return { ...state, invoice: action.payload };
    case GET_INVOICE:
      return { ...state, invoice: action.payload };
    case ADD_NEW_RECEIPT:
    case ADD_NEW:
      return { ...state, invoices: [...state.invoices, action.payload] };
    case UPDATE:
      return {
        ...state,
        invoices: state.invoices.map((invoice) =>
          invoice._id === action.payload._id ? action.payload : invoice
        ),
      };
    case DELETE:
      return {
        ...state,
        invoices: state.invoices.filter(
          (invoice) => invoice._id !== action.payload
        ),
      };
    case RE_GENERATE_TRANSACTIONS:
      return {
        ...state,
        invoices: state.invoices.map((invoice) =>
          invoice._id === action.payload._id ? action.payload : invoice
        ),
      };
    default:
      return state;
  }
};

export default invoices;

//   const invoices =( state = { invoices: [], }, action ) => {
//     switch (action.type) {
//         case FETCH_ALL:
//             return { ...state, invoices: action.payload }

//         case GET_INVOICE:
//             return { ...state, invoice: action.payload }

//         case ADD_NEW:
//             return { ...state, invoices: [...state.invoices, action.payload] }

//         case UPDATE:
//             return { ...state, invoices: state.invoices.map((invoice) => invoice._id === action.payload ? action.payload : invoice) }

//         case DELETE:
//         return {...state, invoices: state.invoices.filter((invoice) => invoice._id !== action.payload)}

//         default:
//             return state;
//     }
// }

// export default invoices
